import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import logger from "./services/logService";
import * as serviceWorker from "./serviceWorker";
import "./index.css";
import bootstrap from "bootstrap"; // wichtig für modale Dialoge
import "bootstrap/dist/css/bootstrap.css";
import "font-awesome/css/font-awesome.css";

logger.init();

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
